module.exports = __webpack_public_path__ + "static/rcc-knb61-study-characteristics-mobile-be3e0e6087921e317b63a49f69926ee7.png";